class FileSaveHelper {
  createDownloadAnchor (uri, fileName, contentType) {
    let anchor = document.createElement('a');
    anchor.setAttribute('href', uri);
    //anchor.setAttribute('target', '_blank');
    anchor.setAttribute('download', fileName);
    if (contentType) {
      anchor.setAttribute('type', contentType);
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    return anchor;
  }

  saveFile (url, fileName) {
    let anchor = this.createDownloadAnchor(url, fileName);
    anchor.click();
    anchor.remove();
  }

  // for blob object to save as file.
  saveBlobFile (blob, fileName) {
    // "saveBlobAsFile" is a global custom function for Electron to save blob to file,
    // it was defined in "electron-savefile.js".
    // The reason to use "saveBlobAsFile" function in Electron is to solve the issue that user may
    // change the extension of filename on saving-dialog and then save it with invalid extension.
    // The "saveBlobAsFile" function will open saving-dialog with file type filters so that it can keep
    // the file extension correct.
    if (window.saveBlobAsFile) {
      return window.saveBlobAsFile(blob, fileName);
    }

    let URL = window.URL || window.webkitURL;
    let objectUrl = URL.createObjectURL(blob);

    let anchor = this.createDownloadAnchor(objectUrl, fileName, blob.type);
    anchor.click();
    anchor.remove();

    // prevent object to be removed before browser download it.
    setTimeout(function(){
      URL.revokeObjectURL(objectUrl);
    }, 5000)
  }
}

export default new FileSaveHelper();